module.exports = __webpack_public_path__ + "static/img/liveControl-bg3.0051765f.png";